import React, { useState, useContext } from "react"
import * as styles from "./Styles/List.module.scss"
// import { PlaceImage } from "../types/place"
import ImageModal from "../Common/ImageModal"
import { PCViewContext } from "../Common/PCViewContext"

const List = (props) => {
  const [selectedImage, setSelectedImage] = useState(null)
  const onImageClick = (e, image) => {
    e.preventDefault()
    setSelectedImage(image)
  }

  return (
    <React.Fragment>
      <div className={styles.imageList}>
        {props.images &&
          props.images.map((image, i) => (
            <div key={i} className={styles.image}>
              <a
                href="#"
                onClick={(e) => {
                  onImageClick(e, image)
                }}
              >
                <img src={image.url} />
              </a>
            </div>
          ))}
      </div>
      <ImageModal
        image={selectedImage}
        show={selectedImage != null}
        onHide={() => {
          setSelectedImage(null)
        }}
      />
    </React.Fragment>
  )
}

const ListWrapper = (props) => {
  const isPC = useContext(PCViewContext)
  return (
    <React.Fragment>
      {isPC && (
        <div className={styles.pcContainer}>
          <List {...props} />
        </div>
      )}
      {!isPC && (
        <div className={styles.spContainer}>
          <List {...props} />
        </div>
      )}
    </React.Fragment>
  )
}

export default ListWrapper
